import { render, staticRenderFns } from "./EventoClub.vue?vue&type=template&id=86166fbe"
import script from "./EventoClub.vue?vue&type=script&lang=js"
export * from "./EventoClub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports